import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";   // we will create this
import AuthenticatorPage from "./pages/AuthenticatorPage";
import Blog from "./pages/Blog";
import AboutPage from "./pages/AboutPage";
import Scroll from "./components/Scroll";
import GetStartedPage from "./pages/Getstartedpage";     // NEW
import OnboardingFlow from "./pages/Onboardingflow";       // NEW
import BatteryPassportPage from "./pages/BatteryPassportPage";  


function App() {
  return (
    <>
    <Scroll />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/authenticator" element={<AuthenticatorPage />} />
        <Route path="/blog" element={<Blog />} />
         <Route path="/get-started" element={<GetStartedPage />} /> 
        <Route path="/onboarding" element={<OnboardingFlow />} /> 
        <Route path="/battery-passport" element={<BatteryPassportPage />} />
      </Routes>
    </>
  );
}

export default App;
